export const QUERY_PARAMS = {
    selectPlayers: {
        name: "selectPlayers",
        value: "1",
    },
};
//# sourceMappingURL=constants.js.map